export default __webpack_public_path__ + "static/1deskbench-33827771b6a139becac34effeee86399.png";